import { useState } from 'react';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Spinner } from '../../../../../components/Spinner';
import { states } from '../../../../../utils/states';
import { NumericFormat } from 'react-number-format';
import { useClockContext } from '../../../../../context/clock-context';

function ConsumerPopoverAddressForm({
  consumerAddressLine1,
  consumerAddressLine2,
  consumerCity,
  consumerState,
  consumerZip,
  updateConsumer,
}) {
  const { setConsumerLocation } = useClockContext();

  const [isOpen, setIsOpen] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const [address, setAddress] = useState({
    addressLine1: consumerAddressLine1,
    addressLine2: consumerAddressLine2,
    city: consumerCity,
    state: consumerState,
    zip: consumerZip,
  });

  const handleSave = async () => {
    setSpinner(true);
    await updateConsumer({ ...address });
    setConsumerLocation({ city: address.city, state: address.state, country: 'US' });
    setSpinner(false);
    setIsOpen(false);
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
    setAddress({
      addressLine1: consumerAddressLine1,
      addressLine2: consumerAddressLine2,
      city: consumerCity,
      state: consumerState,
      zip: consumerZip,
    });
  };

  return (
    <>
      <Form.Label className="bo-common-input-label mt-3">Address</Form.Label>
      <OverlayTrigger
        trigger="click"
        placement="bottom-start"
        show={isOpen}
        popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 0] } }] }}
        overlay={
          <Popover className="custom-popover">
            <Popover.Body className="bo-common-popover-form-menu">
              <Spinner visible={spinner} size={36}>
                <Form.Label className="bo-common-popover-form-menu-label">
                  Address line 1
                </Form.Label>
                <Form.Control
                  type="text"
                  className="bo-common-popover-form-menu-input"
                  value={address.addressLine1}
                  onChange={e => setAddress({ ...address, addressLine1: e.target.value })}
                />
                <Form.Label className="bo-common-popover-form-menu-label mt-2">
                  Address line 2
                </Form.Label>
                <Form.Control
                  type="text"
                  className="bo-common-popover-form-menu-input"
                  value={address.addressLine2}
                  onChange={e => setAddress({ ...address, addressLine2: e.target.value })}
                />
                <div className="d-flex mt-2 gap-2">
                  <div>
                    <Form.Label className="bo-common-popover-form-menu-label">City</Form.Label>
                    <Form.Control
                      type="text"
                      className="bo-common-popover-form-menu-input"
                      value={address.city}
                      onChange={e => setAddress({ ...address, city: e.target.value })}
                    />
                  </div>
                  <div>
                    <Form.Label className="bo-common-popover-form-menu-label">State</Form.Label>
                    <Form.Select
                      className="bo-common-popover-form-menu-input bo-w-80"
                      value={address.state}
                      onChange={e => setAddress({ ...address, state: e.target.value })}
                    >
                      {states.map(state => (
                        <option value={state} key={state}>
                          {state}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div>
                    <Form.Label className="bo-common-popover-form-menu-label">Zip</Form.Label>
                    <NumericFormat
                      type="text"
                      className="bo-common-popover-form-menu-input bo-w-100"
                      value={address.zip}
                      onChange={e => setAddress({ ...address, zip: e.target.value })}
                      maxLength={5}
                      customInput={Form.Control}
                      isAllowed={values => values.formattedValue.length <= 5}
                      allowNegative={false}
                      decimalScale={0}
                      allowLeadingZeros
                    />
                  </div>
                </div>
                <div className="mt-2 d-flex justify-content-between">
                  <Button
                    className="bo-common-button"
                    onClick={handleSave}
                    disabled={
                      !address.addressLine1 ||
                      !address.city ||
                      !address.state ||
                      address.zip.length !== 5
                    }
                  >
                    Save
                  </Button>
                  <Button className="bo-common-button" onClick={handleToggle}>
                    Cancel
                  </Button>
                </div>
              </Spinner>
            </Popover.Body>
          </Popover>
        }
      >
        <Button className="bo-common-text-input-container" onClick={handleToggle}>
          <div className="me-auto">
            <Form.Control
              className="bo-common-text-input bo-w-150"
              type="text"
              readOnly
              value={consumerAddressLine1}
            />
            <Form.Control
              className="bo-common-text-input bo-w-150"
              type="text"
              readOnly
              value={consumerAddressLine2}
            />
            <div className="d-flex">
              <Form.Control
                className="bo-common-text-input"
                type="text"
                readOnly
                value={consumerCity}
              />
              <Form.Control
                className="bo-common-text-input"
                type="text"
                readOnly
                value={consumerState}
              />
              <Form.Control
                className="bo-common-text-input"
                type="text"
                readOnly
                value={consumerZip}
              />
            </div>
          </div>
          <div className="bo-common-input-button-container">
            <div className="bo-common-input-button-icon">
              <FontAwesomeIcon icon={faPencil} color="#5946A4" size="sm" />
            </div>
          </div>
        </Button>
      </OverlayTrigger>
    </>
  );
}

export default ConsumerPopoverAddressForm;
